import TerminalCouplingTable from "../../features/terminals/components/Terminal-Coupling-Table/TerminalCouplingTable";

export default function TerminalsCouplingPage() {
  return (
    <div>
      <TerminalCouplingTable></TerminalCouplingTable>
    </div>
  );
}
